const ROLES = [
	'Manager',
	'InfrastructureManager',
	'Maintainer',
	'Admin',
	'InfrastructureTechnician',
	'Technician',
	'InternalServer',
	'ReadOnly'
]
export function getHighestRole(roles: string[]) {
	if (roles) {
		for (const role of ROLES) {
			if (roles.includes(role)) {
				return role
			}
		}
	}

	return null
}

export function CheckRole(requireRoles: string[], userRoles: string[]) {
	return requireRoles.some(item => userRoles.includes(item))
}
